import { defaultObj } from './state'

// Utilities
import CreditCard from '../../utility/creditCardUtil'
import isEmpty from '../../utility/isEmpty'

import { DisbursementTypeEnum } from '../../constants'

export default {
  setPaymentData (state, paymentData) {
    state.paymentSession = true

    if (paymentData.brand) {
      state.brand = paymentData.brand
    }

    if (paymentData.paymentCardToken !== undefined) { // card token will be set to null when making a $0 refi payment (service will submit it as cash payment)
      state.paymentCardToken = paymentData.paymentCardToken
    }

    if (paymentData.paymentCardIds !== undefined) { // cardId will be set to null when making a $0 refi payment (service will submit it as cash payment)
      state.paymentCardIds = paymentData.paymentCardIds
    }

    if (paymentData.cardHolderName) {
      state.cardHolderName = paymentData.cardHolderName
    }

    if (paymentData.cardNumber) {
      state.cardNumber = paymentData.cardNumber.slice(-4)
    }

    if (paymentData.cardType) {
      state.cardType = paymentData.cardType
    }

    if (paymentData.guestCard !== undefined) {
      state.guestCard = paymentData.guestCard
    }

    if (paymentData.saveGuestCard !== undefined) {
      state.saveGuestCard = paymentData.saveGuestCard
    }

    if (paymentData.cvv !== undefined) {
      state.cvv = paymentData.cvv
    }

    if (paymentData.expirationMonth !== undefined) {
      state.expirationMonth = paymentData.expirationMonth
    }

    if (paymentData.expirationYear !== undefined) {
      state.expirationYear = paymentData.expirationYear
    }

    if (paymentData.isRefi !== undefined) {
      state.isRefi = paymentData.isRefi
    }

    if (paymentData.loan) {
      state.loan = paymentData.loan
    }

    if (paymentData.paymentAmount !== undefined) {
      state.paymentAmount = paymentData.paymentAmount
    }

    if (paymentData.paymentAmountType) {
      state.paymentAmountType = paymentData.paymentAmountType
    }

    if (paymentData.storePhoneNumber) {
      state.storePhoneNumber = paymentData.storePhoneNumber
    }

    if (paymentData.isAlternatesTurn !== undefined) {
      state.isAlternatesTurn = paymentData.isAlternatesTurn
    }

    if (paymentData.alternateProfileId) {
      state.alternateProfileId = paymentData.alternateProfileId
    }

    if (paymentData.alternateDiscAcknowledge) {
      state.alternateDiscAcknowledge = paymentData.alternateDiscAcknowledge
    }

    if (paymentData.alternateContact) {
      state.alternateContact = paymentData.alternateContact
    }

    if (paymentData.preventRefi !== undefined) {
      state.preventRefi = paymentData.preventRefi
    }

    if (paymentData.paymentType) {
      state.paymentType = paymentData.paymentType
    }

    if (paymentData.disbursementAmount !== undefined) {
      state.disbursementAmount = paymentData.disbursementAmount
    }

    if (paymentData.paymentKey !== undefined) {
      state.paymentKey = paymentData.paymentKey
    }

    if (paymentData.disbursementType !== undefined) {
      state.disbursementType = paymentData.disbursementType
    }

    if (Array.isArray(paymentData.ancillaryProducts)) {
      state.ancillaryProducts = paymentData.ancillaryProducts
    }

    if (paymentData.ancillaryConfirmText !== undefined) {
      state.ancillaryConfirmText = paymentData.ancillaryConfirmText
    }

    if (paymentData.ancillaryRequiredText !== undefined) {
      state.ancillaryRequiredText = paymentData.ancillaryRequiredText
    }

    if (paymentData.ancillaryShowApptLink !== undefined) {
      state.ancillaryShowApptLink = paymentData.ancillaryShowApptLink
    }

    if (paymentData.migrateProduct !== undefined) {
      state.migrateProduct = paymentData.migrateProduct
    }

    if (paymentData.externalNavigation !== undefined) {
      state.externalNavigation = paymentData.externalNavigation
    }

    if (paymentData.principleBalance !== undefined) {
      state.principleBalance = paymentData.principleBalance
    }

    if (paymentData.estimatedPayment !== undefined) {
      state.estimatedPayment = paymentData.estimatedPayment
    }

    if (paymentData.guestPayment !== undefined) {
      state.guestPayment = paymentData.guestPayment
    }

    if (paymentData.riskCheck !== undefined) {
      state.riskCheck = paymentData.riskCheck
    }

    if (paymentData.ofrPaymentValue !== undefined) {
      state.ofrPaymentValue = paymentData.ofrPaymentValue
    }

    if (paymentData.pastDueAmount !== undefined) {
      state.pastDueAmount = paymentData.pastDueAmount
    }

    if (paymentData.isReapply !== undefined) {
      state.isReapply = paymentData.isReapply
    }

    if (paymentData.maxReapplyAmount !== undefined) {
      state.maxReapplyAmount = paymentData.maxReapplyAmount
    }

    if (paymentData.settlementDiscountAmount !== undefined) {
      state.settlementDiscountAmount = paymentData.settlementDiscountAmount
    }
  },

  setDisburseCard (state, data) {
    if (data.cardIds !== undefined) {
      state.disburseCardIds = data.cardIds
    }

    if (data.cardHolderName) {
      state.disburseCardHolderName = data.cardHolderName
    }

    if (data.cardNumber) {
      state.disburseCardNumber = data.cardNumber.slice(-4)
    }

    if (data.cardType) {
      state.disburseCardType = data.cardType
    }
  },

  setDisburseBank (state, { bankId, bankNumber }) {
    if (bankId !== undefined) {
      state.disburseBankId = bankId
    }

    if (bankNumber !== undefined) {
      state.disburseBankNumber = bankNumber.slice(-4)
    }

    state.disbursementType = DisbursementTypeEnum.bank
  },

  saveOriginationInfo (state, { applicationId, initiatorDisclosures, initiatorDisclosureData, disclosureSubmitted, isInitiator, productId, storeId }) {
    if (applicationId) {
      state.origination.applicationId = applicationId
    }

    if (disclosureSubmitted) {
      state.origination.disclosureSubmitted = disclosureSubmitted
    }

    if (isInitiator) {
      if (initiatorDisclosures) {
        state.origination.initiatorDisclosureDocuments = initiatorDisclosures
      }

      if (initiatorDisclosureData) {
        state.origination.initiatorDisclosureData = initiatorDisclosureData
      }
    }

    if (productId) {
      state.origination.productId = productId
    }

    if (storeId) {
      state.origination.storeId = storeId
    }
  },

  /**
   * Resets guest card flags. Currently only works for payment card.
   */
  resetGuestCard (state, { cardIds }) {
    if (CreditCard.isSameCard(cardIds, state.paymentCardIds)) {
      state.guestCard = defaultObj.guestCard
      state.saveGuestCard = defaultObj.saveGuestCard
    }
  },

  clearDisburseCard (state) {
    state.disburseCardIds = undefined
    state.disburseCardHolderName = ''
    state.disburseCardNumber = ''
    state.disburseCardType = ''
  },

  endPaymentSession (state) {
    state.paymentSession = false
  },

  clearPaymentData (state) {
    const guestCard = state.guestCard
    const saveGuestCard = state.saveGuestCard
    const isAddOnLocked = state.isAddOnLocked
    state = Object.assign(state, defaultObj, { guestCard, saveGuestCard, isAddOnLocked }) // Reset all except guest card and addOnLocked
  },

  resetPaymentAmount (state) {
    state.paymentAmount = defaultObj.paymentAmount
    state.paymentAmountType = defaultObj.paymentAmountType
    state.preventRefi = defaultObj.preventRefi
    state.isRefi = defaultObj.isRefi
  },

  clearPaymentCardData (state) {
    state.paymentCardToken = ''
    state.paymentCardIds = []
    state.cardHolderName = ''
    state.cardNumber = ''
    state.cardType = ''
    state.cvv = ''
    state.expirationMonth = 0
    state.expirationYear = 0
  },

  setPaymentResult (state, data) {
    state.result = data
  },

  setOriginationResult (state, { error, loanHeader, loanId, newDueDate, productId, storeId }) {
    state.result = {
      error,
      newLoanHeaderId: loanHeader,
      newLoanId: loanId,
      newLoanDueDate: newDueDate,
      newLoanProductId: productId,
      newLoanStoreId: storeId
    }
  },

  clearPaymentResult (state) {
    state.result = null
  },

  paymentPending (state) {
    state.pending = true
  },

  paymentComplete (state) {
    state.pending = false
  },

  hideModalForAlternate (state) {
    state.showAlternateSpousalConsentModal = false
  },

  setDemoRequirements (state, data) {
    const demoOptions = data.demographicOptions
    if (demoOptions === undefined) {
      return
    }

    if ([demoOptions.race, demoOptions.height, demoOptions.gender, demoOptions.weight].includes(true)) {
      state.demographicsNeeded = true
      state.demographicData = data
    } else {
      state.demographicsNeeded = false
    }
  },

  setAutoPay (state, data) {
    if (isEmpty(data)) {
      return
    }

    if (data.enrolled !== undefined) {
      state.autoPay.enrolled = data.enrolled
    }

    if (data.required !== undefined) {
      state.autoPay.required = data.required
    }

    // Allowing auto pay props below to be cleared if not enrolling

    if (data.method !== undefined || data.enrolled === false) {
      state.autoPay.method = data.method
    }

    if (data.methodId !== undefined || data.enrolled === false) {
      state.autoPay.methodId = data.methodId
    }

    if (data.methodCardType !== undefined || data.enrolled === false) {
      state.autoPay.methodCardType = data.methodCardType
    }

    if (data.methodDisplayNumber !== undefined || data.enrolled === false) {
      state.autoPay.methodDisplayNumber = data.methodDisplayNumber
    }

    if (data.methodExpirationMonth !== undefined || data.enrolled === false) {
      state.autoPay.methodExpirationMonth = data.methodExpirationMonth
    }

    if (data.methodExpirationYear !== undefined || data.enrolled === false) {
      state.autoPay.methodExpirationYear = data.methodExpirationYear
    }

    if (data.scheduledAmount !== undefined || data.enrolled === false) {
      state.autoPay.scheduledAmount = data.scheduledAmount
    }

    if (data.scheduledDate !== undefined || data.enrolled === false) {
      state.autoPay.scheduledDate = data.scheduledDate
    }
  },

  completedDemographicsCheck (state) {
    state.demographicsNeeded = false
  },

  setAddOnLock (state, isLocked) {
    state.isAddOnLocked = isLocked
  },

  restoreState (state, data) {
    return new Promise(resolve => { // Best way I could think of to make sure state was restored before I push the route
      resolve(Object.assign(state, data))
    })
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
